<template>

  <div id="app" @click="aaa">
    <input values="0001" hidden/>
    <div id="nav" v-if="!NOnav">
      <div class="flex1 img">
        <img class="logo" src="./assets/logo.png" alt="" />
      </div>
      <div class="flex2 text-no" v-if="tabShow">
        <div :class="urlIndex == 1 ? 'border1' : ''" @click="kk('bill')">
          账单
        </div>
        <div :class="urlIndex == 2 ? 'border1' : ''" @click="kk('invoice')">
          发票
        </div>
        <div
          v-show="deposit"
          :class="urlIndex == 5 ? 'border1' : ''"
          @click="kk('prestore')"
        >
          预存
        </div>
        <div
          :class="urlIndex == 3 ? 'border1' : ''"
          @click="kk('collectionPayment')"
        >
          代收货款
        </div>
        <div :class="urlIndex == 4 ? 'border1' : ''" @click="kk('setTing')">
          月结信息
        </div>
      </div>
      <div class="flex1 info">
        <div class="user">
          <el-popover
            popper-class="log-out"
            placement="top"
            width=""
            v-model="visible"
          >
            <div
              class="button-box"
              style="
                padding: 0px 0;
                text-align: center;
                width: 125px;
                border: 1px #ccc solid;
                line-height: 40px;
              "
              @click="quit"
            >
              退出登录
            </div>

            <div
              class="button-box"
              style="
                padding: 0px 0;
                text-align: center;
                width: 125px;
                border: 1px #ccc solid;
                line-height: 40px;
              "
              @click="showSwitchAccountPopUpBox()"
            >
              切换账号
            </div>
            <div class="df" slot="reference" style="align-items: center">
              <div class="ipeon">
                <p class="text1">{{ userName }}</p>
                <p class="text2">{{ phoneNum }}</p>
              </div>
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
          <div class="Switch-account-pop-up-box" v-if="SwitchAccountPopUpBox">
            <h4>账号选择</h4>
            <el-select v-if="IsDropDownBox" v-model="value">
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.customerCode + '    ' + item.customerName"
                :value="index"
              >
              </el-option>
            </el-select>
            <div v-else class="content">
              您选择的客户编码为：{{
                options[value].customerCode
              }}，客户名称：{{
                options[value].customerName
              }}，请确认是否继续切换！
            </div>
            <el-row class="but" v-if="IsDropDownBox">
              <el-button plain @click="SwitchAccountPopUpBox = false"
                >取消</el-button
              >
              <el-button plain @click="IsDropDownBox = false">确认</el-button>
            </el-row>
            <el-row class="but" v-if="!IsDropDownBox">
              <el-button plain @click="IsDropDownBox = true"
                >返回修改</el-button
              >
              <el-button plain @click="RequestSwitch">确认切换</el-button>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { paths } from "./utils/pathNew";
import API from "./api/bill";
const api = new API();
export default {
  data() {
    return {
      customerCode: window.localStorage.getItem("customerCode"),
      customerName: window.localStorage.getItem("customerName"),
      NOnav: false,
      deposit: window.localStorage.getItem("deposit"),
      userName: window.localStorage.getItem("userName"),
      phoneNum: window.localStorage.getItem("phoneNum"),
      visible: false,
      url: "",
      tabShow: false,
      IsDropDownBox: true,
      SwitchAccountPopUpBox: false,
      options: [],
      value: window.localStorage.getItem("customerCode") +"      " +window.localStorage.getItem("userName"),
    };
  },
  watch: {
    $route(to) {
      if (to.path == "/login") {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
      if (to.path == "/login/consultationService") {
        this.NOnav = true;
      } else if (to.path == "/ok") {
        this.NOnav = true;
      } else {
        this.NOnav = false;
      }
    },
  },
  computed: {
    ...mapState({
      urlIndex: function (state) {
        return state.urlIndex;
      },
    }),
  },
  methods: {
    aaa(){
      if(this.customerCode != window.localStorage.getItem("customerCode") ){
        location.reload()
      }
    },
    // 确认切换
    RequestSwitch() {
      this.changeCustomer()
      this.SwitchAccountPopUpBox = false;
    },
    async changeCustomer() {
      let item = this.options[this.value].customerCode
      let res = await api.changeCustomer(item);
      window.localStorage.setItem("token",res);
      location.reload()
      this.queryCustomerInfo()
    },
    showSwitchAccountPopUpBox() {
      this.value = window.localStorage.getItem("customerCode") +"      " +window.localStorage.getItem("userName"),
      this.IsDropDownBox = true
      this.SwitchAccountPopUpBox = !this.SwitchAccountPopUpBox;
      this.visible = false;
      this.queryCustomerInfoList();
    },
    async queryCustomerInfoList() {
      let res = await api.queryCustomerInfoList();
      this.options = res;
    },
    async quit() {
      //退出
      api.logout().then(() => {
        localStorage.clear(); //删除所有会话存储项
        window.location.href = "https://www.deppon.com";
      });
    },
    kk(i) {
      let url2 = window.location.hash;
      if (i == "bill") {
        if (url2 == "#/") return;
        this.$store.commit("urlIndex", 1);
        this.$router.push({ path: "/" });
        this.$store.commit("billIndex", 2); // 这里每次点击账单/ 设置默认值 本期
      } else if (i == "invoice") {
        if (url2 == "#/invoice") return;
        this.$store.commit("urlIndex", 2);
        this.$router.push({ path: "/invoice" });
      } else if (i == "collectionPayment") {
        if (url2 == "#/collectionPayment") return;
        this.$store.commit("urlIndex", 3);
        this.$router.push({ path: "/collectionPayment" });
      } else if (i == "setTing") {
        if (url2 == "#/setTing") return;
        this.$store.commit("urlIndex", 4);
        this.$router.push({ path: "/setTing" });
      } else if (i == "prestore") {
        if (url2 == "#/prestore") return;
        this.$store.commit("urlIndex", 5);
        this.$router.push({ path: "/prestore" });
      }
    },
    //查询客户基础信息
    async queryCustomerInfo() {
      let token = window.localStorage.getItem("token");
      debugger
      // 如果有参数则请求，没有跳过
      if (token) {
        // window.localStorage.setItem("token", token);
        let res = await api.queryCustomerInfo();
        // console.info(res);
        this.deposit = res.data.deposit;
        window.localStorage.setItem("userName", res.data.customerName);
        window.localStorage.setItem("deposit", res.data.deposit);
        window.localStorage.setItem("customerCode", res.data.customerCode);
        window.localStorage.setItem("role", res.data.role);
        this.userName = res.data.customerName;
        this.customerCode = res.data.customerCode
        let phoneNum = res.data.phoneNumber;
        let text2 = phoneNum.substring(0, 3) + "****" + phoneNum.substring(7);
        this.phoneNum = text2;
        window.localStorage.setItem("phoneNum", text2);
        window.localStorage.setItem("realPhoneNum", res.data.phoneNumber);
        // window.localStorage.setItem("userinfo", JSON.stringify(res.data));
        // this.$router.push({ path: "/" });
      }
    },
  },
  mounted() {
    debugger
    this.$nextTick(() => {
       this.queryCustomerInfo(); //客户基础信息,只请求一次
      // console.log(11111111111111111,this.$route)
    });
  },
  created() {
    this.url = window.location.hash;
    this.$store.commit("urlIndex", paths(this.url));
    this.queryCustomerInfo(); //客户基础信息,只请求一次
    if (this.$route.path == "/login") {
      this.tabShow = false;
    } else {
      this.tabShow = true;
    }
    if (this.$route.path == "/login/consultationService") {
      this.NOnav = true;
    } else if (this.$route.path == "/ok") {
      this.NOnav = true;
    } else {
      this.NOnav = false;
    }
  },
};
</script>
<style lang="less">
.log-out {
  // padding: 12px 0px;
  text-align: center;
  cursor: pointer;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul,
ol {
  list-style: none;
}
html,
body {
  width: 100%;
  height: 100%;
}
body .el-table th.gutter {
  display: table-cell !important;
}
#app {
  font-family: "Avenir", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
}
#nav {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .flex1 {
    width: 234px;
    .logo {
      display: flex;
      padding-left: 24px;
    }
  }
  .flex2 {
    flex: 2;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      min-width: 64px;
      margin-right: 32px;
      text-align: center;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      line-height: 62px;
      &:hover {
        color: #008cffff;
        border-bottom: 2px solid #008cffff;
        max-width: 64px;
      }
    }
    .border1 {
      color: #008cffff;
      width: 64px;
      border-bottom: 2px solid #008cffff;
    }
  }
  .button-box {
    width: 100px;
    height: 30px;
    border: 1px #2c3e50 solid;
    line-height: 30px;
  }
  .info {
    .user {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 64px;
      padding-right: 25px;
      .Switch-account-pop-up-box {
        position: absolute;
        top: 50px;
        width: 300px;
        background-color: #fff;
        z-index: 999;
        box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
        padding: 30px;
        h4 {
          text-align: left;
          margin-bottom: 50px;
        }
        .but {
          margin-top: 50px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .imgs {
      width: 40px;
      height: 40px;
      .head-portrait {
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }
    }
    .ipeon {
      text-align: right;
      margin: 0 13px 0;
      text-align: right;
      .text1 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.88);
      }
      .text2 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.4);
        line-height: 20px;
      }
    }
  }
}
</style>
